// src/components/TemplateSelector.jsx
import React, { useEffect, useState } from 'react';
import { getAllTemplates } from '../utils/supabaseUtils';
import { useNavigate } from 'react-router-dom';

const TemplateSelector = ({ uploadedImageURL }) => {
  const [templates, setTemplates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTemplates = async () => {
      const { data } = await getAllTemplates();
      setTemplates(data);
    };
    fetchTemplates();
  }, []);

  const handleSelect = (templateId) => {
    navigate(`/customize/${templateId}`, { state: { uploadedImageURL } });
  };

  return (
    <div>
      <h2>Select a Template</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '20px' }}>
        {templates.map((template) => (
          <div key={template.id} style={{ border: '1px solid #ccc', padding: '10px', cursor: 'pointer' }}
            onClick={() => handleSelect(template.id)}>
            <h3>{template.name}</h3>
            <p>{template.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateSelector;